import { SendLixiRequest } from '../../../../types';
import { InceptHeader } from '../../../constants/InceptHeader';
import { ConstructPost } from '../../../types/ConstructPost';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { APPLICATION_BASE_PATH } from '../constants/applicationBasePath';

export const postApplicationRunPpsrIntegration = async (
  constructPost: ConstructPost,
  uuid: string,
  definitionName: string,
  data: SendLixiRequest,
): Promise<NonPaginatedResponse<null> | undefined> =>
  constructPost(
    `${APPLICATION_BASE_PATH}/${uuid}/illion/ppsr`,
    {
      data,
      headers: {
        [InceptHeader.DefinitionName]: definitionName,
      },
    },
    { preventDefaultErrorToast: true },
  );
